// policies
const LOAD_POLICIES = '🗄  Load policies'
const FETCH_POLICIES_PENDING = '🕐 Fetch policies pending'
const FETCH_POLICIES_SUCCESS = '✅ Fetch policies success'
const FETCH_POLICIES_FAILURE = '❌ Fetch policies failed'
const SET_POLICY_TYPE = '📦 Set policy type'

// group policies
const LOAD_GROUP_POLICIES = '🗄  Load group policies'
const FETCH_GROUP_POLICY_PENDING = '🕐 Fetch group policies pending'
const FETCH_GROUP_POLICIES_SUCCESS = '✅ Fetch group policies success'
const FETCH_GROUP_POLICY_FAILURE = '❌ Fetch group policies failed'

export default {
  LOAD_POLICIES,
  FETCH_POLICIES_PENDING,
  FETCH_POLICIES_SUCCESS,
  FETCH_POLICIES_FAILURE,
  LOAD_GROUP_POLICIES,
  FETCH_GROUP_POLICY_PENDING,
  FETCH_GROUP_POLICIES_SUCCESS,
  FETCH_GROUP_POLICY_FAILURE,
  SET_POLICY_TYPE,
}
